import { render, staticRenderFns } from "./HomeWorkEntryTable.vue?vue&type=template&id=5272cc7e"
import script from "./HomeWorkEntryTable.vue?vue&type=script&lang=js"
export * from "./HomeWorkEntryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports